module.exports = __webpack_public_path__ + "img/triangle.3e3334ec.svg";